<div class="page-shell">
  <div class="page-container page-section-tight">
    <!-- <div *ngIf="showUserBackButton" class="mb-4">
      <button type="button" class="page-btn page-btn-secondary px-6" (click)="goBackToUserDashboard()">
        Back
      </button>
    </div> -->
    <button
        (click)="location.back()" 
        class="px-3 py-2 mb-3 rounded-md bg-[#9AA0B3] text-sm text-white flex items-center gap-2 hover:bg-[#8d93a4] duration-300"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" stroke-color="currentColor">
          <path d="M0 0h24v24H0z" fill="none" />
          <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
              <path stroke-dasharray="20" d="M21 12h-17.5">
                  <animate fill="freeze" attributeName="stroke-dashoffset" dur="0.3s" values="20;0" />
              </path>
              <path stroke-dasharray="12" stroke-dashoffset="12" d="M3 12l7 7M3 12l7 -7">
                  <animate fill="freeze" attributeName="stroke-dashoffset" begin="0.3s" dur="0.2s" to="0" />
              </path>
          </g>
      </svg>
      <p>Back</p>
    </button>

    <app-page-header
      [title]="mode === 'create' ? 'Register New Vendor' : 'Update Vendor'"
      subtitle="Complete the form below to register a new vendor"
    ></app-page-header>

    <div class="mt-8">
      <app-wizard-stepper [steps]="steps" [activeIndex]="activeStep"></app-wizard-stepper>
    </div>

    <form class="mt-8" [formGroup]="form" (ngSubmit)="isLastStep ? submit() : goNext()">
      <ng-container [ngSwitch]="activeStep">

        @if (prefillBusy) {
          <div class="size-full pt-8 flex items-center justify-center">
            <div class="flex flex-col items-center gap-3">
              <div
                class="size-10 animate-spin rounded-full border-4 border-slate-200 border-t-vms-bg-secondary"
              ></div>
              <p class="text-sm font-medium text-slate-500 text-center">
                Pre-filling form...
              </p>
            </div>
          </div>
        } @else {
          <app-business-info-step
            *ngSwitchCase="0"
            [group]="businessInfoGroup"
            [busyAsin]="busyAsin"
            [busyCac]="busyCac"
            [readOnly]="mode === 'edit' || businessInfoReadOnly"
            [mdas]="mdaList?.data ?? []"
            [categories]="categoryList?.data ?? []"
            (validateAsin)="validateAsin()"
            (verifyCac)="verifyCac()"
          ></app-business-info-step>
        }

        <app-directors-step
          *ngSwitchCase="1"
          [directors]="directorsArray"
          [busyVerify]="busyDirectorAsin"
          [duplicateModalMessage]="duplicateDirectorModalMessage"
          (addDirector)="addDirector()"
          (removeDirector)="removeDirector($event)"
          (verifyAsin)="verifyDirectorAsin($event)"
          (closeDuplicateModal)="closeDuplicateDirectorModal()"
        ></app-directors-step>

        <app-bank-details-step
          *ngSwitchCase="2"
          [group]="bankDetailsGroup"
          [banks]="banks"
          [busyVerify]="busyBankVerify"
        ></app-bank-details-step>

        <app-documents-step
          *ngSwitchCase="3"
          [documents]="documentsArray"
          (fileSelected)="onDocumentFileSelected($event)"
          (removeFile)="removeDocumentFile($event)"
        ></app-documents-step>
      </ng-container>

      <div class="mt-8 flex items-center justify-center gap-4">
        <button
          type="button"
          class="page-btn bg-slate-400 text-white hover:bg-slate-500"
          (click)="goBack()"
          [disabled]="isSubmitting || isFirstStep || isValidatingStep || prefillBusy"
        >
          Back
        </button>

        <button
          type="submit"
          class="page-btn page-btn-primary min-w-[180px]"
          [disabled]="isSubmitting || !canProceedCurrentStep || isValidatingStep || prefillBusy"
          [attr.aria-busy]="isSubmitting && isLastStep ? true : null"
        >

          @if (isLastStep && isSubmitting) {
            <div class="flex items-center gap-2">
              <span
                class="inline-block size-6 animate-spin rounded-full border-4 border-slate-400/40 border-t-white"
                aria-hidden="true"></span>
              <p>
                Submitting...
              </p>
            </div>

          } @else {
            {{ isLastStep ? 'Submit Application' : 'Next' }}
          }
        </button>
        
      </div>
    </form>
  </div>
</div>
